"use client"

import React, { useEffect, useRef } from 'react';

interface JotformEmbedProps {
  src?: string | null;
  title?: string;
  minHeight?: string;
}

export default function JotformEmbed({ src, title = "Formulario", minHeight = "800px" }: JotformEmbedProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleJotformMessage = (e: MessageEvent) => {
      // Jotform envía mensajes con el formato "id:setHeight:1234"
      if (typeof e.data === 'string') {
        const args = e.data.split(':');
        if (args.length > 0 && args.includes('setHeight') && iframeRef.current) {
          const height = args[args.indexOf('setHeight') + 1];
          if (height) {
            iframeRef.current.style.height = `${height}px`;
            iframeRef.current.style.minHeight = `${Math.max(parseInt(height), parseInt(minHeight))}px`;
          }
        }
      }
    };
    
    window.addEventListener('message', handleJotformMessage);
    return () => window.removeEventListener('message', handleJotformMessage);
  }, [minHeight]);

  return (
    <iframe
      ref={iframeRef}
      src={src || undefined}
      style={{ minHeight, height: minHeight, width: '100%', border: 'none', overflow: 'hidden' }}
      title={title}
      scrolling="no"
    />
  );
}
